import {Context, createContext} from 'solid-js'
import {ThemeProviderBehavior} from './ThemeProvider'
import {EmiTheme} from './emiTheme'

export const ThemeContext: Context<ThemeProviderBehavior> = createContext({
    getTheme: (): EmiTheme => ({}),
})
